'use client';

import { FC, useEffect } from 'react';

import { ESHOP_TEST_ID } from '@telialt/core-eshop/src/test/test-ids';

import { DividerGrid } from '../ProductDetailsPage.styles';
import { ProductDescriptionSkeleton } from './components/ProductDescriptionSkeleton';
import {
    GallerySkeleton,
    ProductDetailsSkeletonWrapper,
    ProductTitleSkeleton,
} from './components/ProductDetailsSkeleton.styles';

export const ProductDetailsSkeleton: FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <ProductDetailsSkeletonWrapper data-test={ESHOP_TEST_ID.PRODUCT_DETAILS_SKELETON}>
            <DividerGrid>
                <GallerySkeleton />
                <div>
                    <ProductTitleSkeleton />
                    <ProductDescriptionSkeleton />
                    <ProductDescriptionSkeleton />
                    <ProductDescriptionSkeleton />
                    <ProductDescriptionSkeleton />
                </div>
            </DividerGrid>
        </ProductDetailsSkeletonWrapper>
    );
};
